import _ from 'lodash';
import React from 'react';
import {
  FormField,
  HelpBlock,
  Textarea,
  Label,
  Row,
} from './form';

export default function withNameTextarea(objectName, name, store, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainInput() {
    const set = store(state => state.set);
    const value = store(state => state[objectName][name]);
    const errors = store(state => state.errors);

    const onChange = e => {
      e && e.preventDefault();

      const v = _.get(e, 'target.value', '');

      set(state => {
        state[objectName][name] = v;
      });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <Textarea
            id={kebab}
            type="text"
            name={name}
            placeholder={label || capitalize}
            value={value || ''}
            onChange={onChange}
          />
          {!!errors[snake] && <HelpBlock>{errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainInput.displayName = capitalize;

  return PlainInput;
}
